// @ts-nocheck

//////////////////////////////////////
//   This file is auto generated   //
//////////////////////////////////////

import * as System_Collections_Generic from "./System_Collections_Generic"
import * as System from "./System"

export type FieldDataType = "Text" | "MultiLineText" | "Integer" | "Float" | "Bool" | "Date" | "TextLookup" | "Link" | "HtmlText" | "TokenEdit" | "OptionLookup"
export const FieldDataType_AllValues = ["Text", "MultiLineText", "Integer", "Float", "Bool", "Date", "TextLookup", "Link", "HtmlText", "TokenEdit", "OptionLookup"] as const
export const defaultFieldDataType: FieldDataType = "Text"

export type ts_Module = "undef" | "theaDispo" | "theaOrchester" | "theaPerso" | "theaKontakt" | "theaChor" | "theaBallett" | "theaLibrary" | "theaOrder" | "theaStatisterie" | "theaStaff" | "theaCostume" | "theaMask" | "theaFund" | "theaInventory"
export const ts_Module_AllValues = ["undef", "theaDispo", "theaOrchester", "theaPerso", "theaKontakt", "theaChor", "theaBallett", "theaLibrary", "theaOrder", "theaStatisterie", "theaStaff", "theaCostume", "theaMask", "theaFund", "theaInventory"] as const
export const defaultts_Module: ts_Module = "undef"

export type DayOfWeekFlag = "all" | "Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday" | "Saturday" | "Sunday"
export const DayOfWeekFlag_AllValues = ["all", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"] as const
export const defaultDayOfWeekFlag: DayOfWeekFlag = "all"

export type WorkingTimeBookingTypeSettings = {
  automaticEndedTimeAccountTypes: System_Collections_Generic.List<System.Int32>
}

export type BookingCategories = "CheckIn" | "CheckOut" | "TimeAccount"
export const BookingCategories_AllValues = ["CheckIn", "CheckOut", "TimeAccount"] as const
export const defaultBookingCategories: BookingCategories = "CheckIn"


